module.exports = __webpack_public_path__ + "media/images/dropdown-sidebar-6aaec480e28171f40714e69140f6247d.svg";